<template>
  <div
    tabindex="0"
    class="interaction-head base file-viewer file-viewer-base mb-0 pt-2 px-2"
    :aria-label="`Interaction text: ${interaction.interactionText.stripHTML(['img', 'Image'], ['input', 'Input blank'])}`"
  >
    <!-- Preview iframe of hosted PDF file: -->
    <div
      v-if="showFilePreview"
      id="interaction-head-file-viewer-embedded-adobe-viewer-sdk"
      class="interaction-head-file-viewer-embedded-adobe-viewer-sdk-wrapper mb-2"
    >
      <div
        :id="pdfViewerIdentifier"
      >
        <!-- Inject PDF file to preview here! -->
      </div>
    </div>
    <div
      v-if="(
        inPrintMicroserviceGeneratingHTMLToDownload
        || inPrintMicroserviceGeneratingPdfToDownload
      )"
    >
      <p
        class="pdf-file-viewer-html-pdf-link"
      >
        (<span style="font-style: italic">Due to certain limitations, we can't display the PDF inline</span>)
        <br />
        <a target="_blank" :href="localInteraction.interactionText">{{ localInteraction.interactionText }}</a>
      </p>
    </div>
  </div>
</template>

<script>

import Interaction from '../../../mixins/Interaction';
import PdfViewer from '@mixins/PdfViewer/PdfViewer.js';

import uuid from 'uuid/v4';

// Custom Helpers:
import { waitForElementToDisplay } from '@utilities';

export default {
  name: 'FileViewerBaseInteractionHead',
  mixins: [
    Interaction,
    PdfViewer,
  ],
  data() {
    return {
      inPrintMicroservice: window.location.href.includes('print'),
      queryParams: new URLSearchParams(window.location.search),
      showFilePreview: false,
      viewerId: uuid(),
    }
  },
  props: {
    perspectiveKey: {
      type: String,
      required: true,
    },
    interactionBodyComponentKey: {
      type: String,
      required: true,
    },
    token: {
      type: String,
      required: false,
    }
  },
  computed: {
    pdfViewerIdentifier() {
      return `interaction-head-file-viewer-pdf-preview-${this.viewerId}`;
    },
    inPrintMicroserviceGeneratingHTMLToDownload() {
      return (
        this.inPrintMicroservice
        && this?.queryParams?.get('autogenerate') === 'html'
      )
    },
    inPrintMicroserviceGeneratingPdfToDownload() {
      return (
        this.inPrintMicroservice
        && this?.queryParams?.get('autogenerate') === 'pdf'
      )
    },
  },
  methods: {
    async previewPDF() {
      if (
        !this?.localInteraction?.interactionText
        || this.inPrintMicroserviceGeneratingHTMLToDownload
        || this.inPrintMicroserviceGeneratingPdfToDownload
      ) return;

      this.showFilePreview = true;
      await this.$nextTick();
      const pdfPreviewDivElement = await waitForElementToDisplay(`#${this.pdfViewerIdentifier}`);
      if (!pdfPreviewDivElement) return;

      this.createAdobeViewerInstance({
        divId: this.pdfViewerIdentifier,
      });
      await this.previewFile({
        resourceLocationUrl: this.localInteraction.interactionText,
      });
    },
  },
  watch: {
    async adobeViewerSDKScriptInjected(newValue, oldValue) { // eslint-disable-line
      if (newValue) {
        await this.previewPDF();
      }
    }
  },
};
</script>

<style lang="scss" scoped>

div[id^="interaction-head-file-viewer-pdf-preview-"] {
  height: 100vh;
  ::v-deep iframe {
    pointer-events: auto;
  }
}

</style>
